import { formatTruncated } from 'src/app/shared/number-format.util';

/**
 * Rótulo de eixo: ponto decimal, sem agrupamento, no máximo 3 casas cortadas e sem
 * preenchimento de zeros (mesma política do axisText das tabelas de ajuste).
 */
export function mapAxisText(value: number): string {
  return formatTruncated(value, { maxDecimals: 3, locale: 'en-US', useGrouping: false });
}

/** Valor de célula (ms): 3 casas fixas, cortadas; "—" quando ausente/não finito. */
export function mapCellText(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return formatTruncated(value, { minDecimals: 3, maxDecimals: 3, locale: 'en-US', useGrouping: false });
}
